import { useQuery } from '@tanstack/react-query';
import type { ChannelEmailConfigResponse } from '@/modules/channels/types';
import { channelsApi } from '../services';

/**
 * GET /channels/:id/email-config — configuração de e-mail→ticket do canal
 * `email-resend` (Plano B, Task 7). `ChannelResponse.config` já traz o mesmo
 * subset resolvido (usado como estado inicial instantâneo em
 * `EmailResendConfig`, evitando flash de loading), mas este hook busca a
 * fonte dedicada para refletir qualquer mudança mais recente.
 */
export const useChannelEmailConfig = (channelId: string | undefined) => {
  return useQuery<ChannelEmailConfigResponse>({
    queryKey: ['channels', channelId, 'email-config'],
    queryFn: () => channelsApi.getEmailConfig(channelId as string),
    enabled: Boolean(channelId),
  });
};
